// After a deploy, a tab opened on the previous build still references its old
// hashed chunks. The next lazy route then 404s ("ChunkLoadError: Loading chunk
// 88549 failed"), and with no error boundary the whole app unmounts to a blank
// page. Reloading picks up the new index.html (served no-cache) and its chunks.

const RELOAD_KEY = 'saf3ai_chunk_reload_at';
// One reload per window: if the new build is itself broken, don't loop.
const RELOAD_GUARD_MS = 30000;

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const name = error.name || '';
  const message = String(error.message || error);
  return name === 'ChunkLoadError'
    || /Loading (CSS )?chunk [\w-]+ failed/i.test(message);
};

export const reloadForNewBuild = ({
  storage = window.sessionStorage,
  reload = () => window.location.reload(),
  now = Date.now(),
} = {}) => {
  let last = 0;
  try {
    last = Number(storage.getItem(RELOAD_KEY)) || 0;
  } catch {
    // Storage unavailable (private mode): still allow a single reload attempt.
  }
  if (last && now - last < RELOAD_GUARD_MS) return false;
  try {
    storage.setItem(RELOAD_KEY, String(now));
  } catch {
    // ignore
  }
  reload();
  return true;
};

export const installChunkReloadHandler = (target = window) => {
  const handle = (error) => {
    if (isChunkLoadError(error)) reloadForNewBuild();
  };
  target.addEventListener('error', (event) => handle(event.error));
  target.addEventListener('unhandledrejection', (event) => handle(event.reason));
};
